import { Preferences } from "@capacitor/preferences"
import type { IPreferences } from "@ports/app"

export function useCapacitorPreferences(): IPreferences {
  return {
    async get(key) {
      const { value } = await Preferences.get({ key })
      return value
    },
    async set(key, value) {
      await Preferences.set({ key, value })
    },
    async remove(key) {
      await Preferences.remove({ key })
    },
  }
}
